import TabComponent from './Tab';

export default TabComponent;
